import { useEffect } from 'react';

import { fetchSubscriptions } from 'store/subscriptions/actions';

import { useDispatch, useSelector } from 'react-redux';
import { selectSubscriptions } from 'store/subscriptions/selectors';

const useSubscriptions = () => {
    const dispatch = useDispatch();
    const { subscriptions, isLoading, isDiscountLoading } = useSelector(selectSubscriptions);

    useEffect(() => {
        dispatch(fetchSubscriptions());
    }, []);

    return { isLoading, subscriptions, isDiscountLoading };
};

export default useSubscriptions;
